import React, { useEffect, useContext, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import useValidationInput from "../../../Hooks/useValidationInput.js";
import useAxiosOperation from "../../../Hooks/useAxiosOperation.js";
import SpinnerIcon from "../../Commands/SpinnerIcon/SpinnerIcon.js";
import useLogIcon from "../../../Hooks/useLogIcon.js";
import { useHistory } from "react-router-dom";
import "../../Styles/globalStyle.css";
import { store } from "../../../store.js";
import Cookies from "js-cookie"
import ExpandCommand from "../../Commands/ExpandCommand/ExpandCommand";
import CollapseCommand from "../../Commands/CollapseCommand/CollapseCommand";
import TaskIcon from "../../Commands/TaskIcon/TaskIcon";
import FormIcon from "../../Commands/FormIcon/FormIcon";
import DropDownListNew from "../../DropDownList/DropDownListNew";
import Autocomplete from "../../Autocomplete/Autocomplete";
import Process from "./Process";
import Task from "./Task";

export default function  Kanban (props) {
  const globalState = useContext(store);
  const [process, setProcess] = useState([1]);
  const { dispatch } = globalState;
  const [token, setToken]  = useState(new URLSearchParams(useLocation().search).get("c_token"));
  const getLogIcon = useLogIcon();
  const isInputValid = useValidationInput();
  const axiosOperation = useAxiosOperation();
  const history = useHistory();
  const  [user, setUser] = useState({ 
    id: 1,
    email : "",
    password : "",
    errors:[]
  })
  
    const getError = (id) => {
    const error =  user.errors.filter(item => item.id == id)[0]
    return <div style={{border:"none", backgroundColor:"transparent", userSelect:"none",
      paddingTop:"0px", marginTop:"0px", height:"15px",  color: "rgb(206, 17, 38)", fontSize: 10}} 
      >{error ? error.text: ""}</div>
  
  };

 
  
  useEffect(() => {
    if (token != null) {
      var userData = JSON.parse(JSON.stringify(user));
      setUser({...userData, loading:true })
      axiosOperation({method:"PATCH"
        , url: "https://flex-services.onrender.com/user/"+ token + "/"
        , body: {confirmed:true, nTry:0}
        }).then(response => 
          { 
            if(response.managedError) {
              const result = response.result.data
              setUser({...userData, log:{type:result.log.type, text:result.log.text, style:result.log.style, activeResendEmail:result.activeReSendEmail}})
            }
            else {
              
              setUser({...userData, log:{text:response.text, style:{fontSize:"12px", color:"rgb(206, 17, 38"}, activeResendEmail:undefined}})
            }
          })

    }
  }, []); //onLoad

  const fireOtherEvent = (e, detail, typeValidation) => {
  
    var userData = JSON.parse(JSON.stringify(user));
    validInput(e.target.value, detail, typeValidation, userData) 
    setUser(userData);
  }

  const fireEventKeyPress = (e, detail, typeValidations) => {
     
    var userData = JSON.parse(JSON.stringify(user));
    userData.errors = userData.errors.filter(error => error.id != detail.id )

    if(typeValidations,  !isInputValid({value: e.key}, typeValidations).isValid) {
      e.preventDefault()
    }
    setUser(userData);
  }

  const validInput = (value, detail, typeValidation, userData) => {
    const eventResponse = isInputValid({value: value}, typeValidation);
    if(eventResponse.isValid) {
      userData.errors = userData.errors.filter(error => error.id != detail.id )
    }
    else {
      userData.errors.push({id:detail.id
        , text: eventResponse.type == "EMAIL" ? "The email is invalid" : "The field is required".replace("field", detail.name)})
    }
  }

  const onClick = () => {
  
    var userData = JSON.parse(JSON.stringify(user));
    validInput(user.email, {id:"Email", name:"Email" }, [{type :"REQUIRE"}], userData) 
    validInput(user.password, {id:"Password", name:"Password" }, [{type :"REQUIRE"}], userData)
    if (userData.errors.length == 0) {
      var userData = JSON.parse(JSON.stringify(user));
      
      setUser({...userData, loading:true })
      
      if (user.log && user.log.activeResendEmail)
        axiosOperation({method:"POST"
        , url: "https://flex-services.onrender.com/user/"
        , body:userData
        }).then(response => 
          { 
            if(response.managedError) {
              const result = response.result.data
              setUser({...userData, log:{type:result.log.type, text:result.log.text, style:result.log.style, activeResendEmail:result.activeReSendEmail}})
            }
            else {
              setUser({...userData, log:{text:response.text, style:{fontSize:"12px", color:"rgb(206, 17, 38"}, activeResendEmail:undefined}})
            }
          })
      else
        axiosOperation({method:"POST"
          , url: "https://flex-services.onrender.com/login/"
          , body: userData
          , headers: {xsrfHeaderName:'X-CSRFToken'}
          }).then(response => 
          { 
            if(response.managedError) {
              const result = response.result.data 
              
              if (result.log.type == "INFO") {
                dispatch({
                  type: "SET_ACCESS_TOKEN",
                  payload: {user:result["user"], accessToken: result["access_token"] }
                });
                history.push('/information')
              } 
              else
                setUser({...userData, log:{type:result.log.type, text:result.log.text, style:result.log.style, activeResendEmail:result.activeReSendEmail}})
              
            }
            else {
              setUser({...userData, log:{text:response.text, style:{fontSize:"12px", color:"rgb(206, 17, 38"}, activeResendEmail:undefined}})
            }
            })
      
    }
    else
      setUser(userData);
  }

  const refreshForm = () => {
  
    const userData = { 
      id: 1,
      email : "",
      password : "",
      errors:[],
      loading:false
    }
   
    setUser(userData);
  }

  const onClickProcessIcon = (id) => {
  
   if (process.includes(id))
    setProcess(process.filter(item => item != id));
  else
  setProcess([...process, id]);
  }

  const canClick = user.errors.length == 0 && !user.loading

  return (
    <React.Fragment>
      <div style = {{ display: "flex", marginLeft:"auto", marginRight:"auto",  width:"1040px"
        , minHeight: "40px", borderRadius: "4px"
        , marginTop:"30px", backgroundColor: "white" }}>
        <div style = {{ marginLeft:"15px", marginTop:"8px"}}> Tasks Board</div>
        <div style = {{ marginLeft:"auto", marginTop:"8px", marginRight:"10px"}}>
          <Autocomplete 
            id={"Process" +props.id} //id={"Autocomplete" + fieldId}
            placeholder={"Unassigned"}
            isWrapped = {true}     
            style={{ width:"130px", height:"12px", fontSize: "14px"}}
            containerStyle={{width:"142px", border: "1px solid red"}}
            emphasised= {false}
            value={"Team A"}
            data = {[{id:1, item:"Team A"}, {id:2, item:"Team B"}]}
            onSelectedItem={(e, itemSelected) => alert(1)}/>
        </div>
        <div style = {{ marginTop:"5px", marginRight:"10px"}}>
          <DropDownListNew
            fontSize={"14px"}
            currentData={[{id:1, item:"User A"},{id:2, item:"User B"}]}
            id={"UsersList"}
            initialValue="All User"
            multiSelection={true}
            selectedValues={[]}
            onDropDownItemClick={(itemSelected) => alert(itemSelected)}
            onlyLabel={false}/>
        </div>
      </div>
      <div style = {{ display: "flex", marginLeft:"auto", marginRight:"auto",  width:"1040px"}}>
        <div style = {{ marginLeft:"25px", marginTop:"8px"}}>Process</div>
        <div style = {{ marginLeft:"155px", marginTop:"8px"}}>New</div>
        <div style = {{ marginLeft:"175px", marginTop:"8px"}}>In Progess</div>
        <div style = {{ marginLeft:"130px", marginTop:"8px"}}>Resolved</div>
        <div style = {{ marginLeft:"143px", marginTop:"8px"}}>Done</div>
        </div>
      <div style = {{display:"flex",  marginLeft:"auto", marginRight:"auto",  width:"1040px", borderRadius: "4px", marginTop:"5px" }}
         onDrop={(e) => alert(e)}
         onDragOver={(e) => alert(e)}
      >
        <Process isExpanded = {process.includes(1)} onClickProcessIcon  = { () => onClickProcessIcon(1) } />
        {process.includes(1) && <React.Fragment>
        <div style = {{  marginRight:"5px",  minWidth:"180px",  maxWidth:"180px", padding: "0 10px 10px 10px", borderRadius: "4px", backgroundColor: "white" }}>
          <Task />
          <Task />
          <Task />
        </div>
        <div style = {{  marginRight:"5px",  minWidth:"180px",  maxWidth:"180px", padding: "0 10px 10px 10px", borderRadius: "4px", backgroundColor: "white" }}>
          <Task />
        </div>
        <div style = {{  marginRight:"5px",  minWidth:"180px",  maxWidth:"180px", padding: "0 10px 10px 10px", borderRadius: "4px", backgroundColor: "white" }}>
          <Task />
        </div>
        <div style = {{  marginRight:"5px",  minWidth:"180px",  maxWidth:"180px", padding: "0 10px 10px 10px", borderRadius: "4px", backgroundColor: "white" }}>
          <Task />
        </div></React.Fragment> }
      </div>
    </React.Fragment>
  );
};

/*
<span style = {{ fontSize:"14px", width:"250px", color:"#212121" }} >Register</span>*/